<template>
  <div class="col-span-1 xl:row-start-1 xl:col-start-2 xl:row-end-1 xl:col-end-5 grid pt-10 pb-2 xl:py-8">
    <div class="col-span-full xl:row-start-1 xl:col-start-1 xl:row-end-1 xl:col-end-5 grid *:px-4 *:pb-4 xl:*:py-0">
      <h3 class="text-center text-white mb-4 font-medium text-2xl xl:text-4xl">
        {{ $t('recommendation.suggestion-page.suggestion-title') }}
      </h3>
      <div class="flex flex-col xl:flex-row gap-6">
        <div
          v-for="(suggestedEventUri, index) of events"
          :key="index"
          class="xl:flex-1 xl:w-0"
          :class="{ ['xl:order-2']: index === 0, ['xl:order-1']: index === 1, ['xl:order-3']: index === 2 }"
        >
          <OrganismLoaderFromUri :uri="suggestedEventUri.uri" class="h-full">
            <template v-if="index < 3" #loading>
              <MoleculeCardRecommendationSuggestion :loading="true" />
            </template>
            <template v-if="index < 3" #default="event">
              <MoleculeCardRecommendationSuggestion
                :concert-status="event.concertStatus"
                :end-date="event.eventEndDate"
                :event-id="event.iConcertId"
                :image="get(event, 'production.teaserImage')"
                :location="get(event, 'room.title')"
                :stream-url="event.streamUrl"
                :title="get(event, 'production.title')"
                :url="event.url"
                :when="event.eventDate"
                :works="get(event, 'production.works')"
                :label="index === 0 ? $t('recommendation.suggestion-page.top-result-label') : undefined"
                :tix-pricing="prepareTixPricing(event.pricing)"
                :tix-sale="prepareTixSale(event)"
              />
            </template>
          </OrganismLoaderFromUri>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import get from 'lodash/get'

defineProps({
  events: { type: Array as PropType<any[]>, required: true },
})

const prepareTixPricing = setupPrepareTixPricing()
const prepareTixSale = setupPrepareTixSale()
</script>

<style scoped lang="scss"></style>
